import * as ActionTypes from "services/state/action-types"

const INITIAL_STATE = {
  offers: [],
  loading: false,
  error: null
}

export function nbo(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_NBO_OFFERS:
      return { ...state, loading: true, error: null }

    case ActionTypes.GET_NBO_OFFERS_SUCCESS:
      return { ...state, loading: false, offers: action.payload }

    case ActionTypes.GET_NBO_OFFERS_FAIL:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/nbo/reducer.js